import { Directive, HostBinding } from '@angular/core';

@Directive({ selector: '[kui-content-header-title]' })
export class KuiContentHeaderTitleDirective {
    @HostBinding('class.title') title = true;
}
